module.exports = __webpack_public_path__ + "124b0175073e279925f7275432ad384d.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/PDF.png
// module id = QWRM
// module chunks = 0